import { HubUserAttributesClient } from 'frontend-preferences-client';
const hubUserAttributesClient = HubUserAttributesClient.forCaller('unified-navigation-ui');
export const COAC0001_TREATMENT_HUB_USER_ATTRIBUTE_KEY = 'GrowthCoaching:COAC0001Treatment';
export const COAC0002_TREATMENT_HUB_USER_ATTRIBUTE_KEY = 'GrowthCoaching:COAC0002Treatment';
export const getTreatmentGroupsFromUserAttributes = () => hubUserAttributesClient.batchFetch({
  [COAC0001_TREATMENT_HUB_USER_ATTRIBUTE_KEY]: 'control',
  [COAC0002_TREATMENT_HUB_USER_ATTRIBUTE_KEY]: 'control'
});